module.exports = __webpack_public_path__ + "img/calendar.586a9478.svg";